<template>
  <div v-if="!loading && !(isWx || isQQ || isDy)" :class="['page', 'page-pc']">
    <div class="page-main">
    <div class="logo-box">
      <img class="logo" src="@/assets/images/logo@2x.png"/>
      <div class="title">觅小书</div>
    </div>
    <div class="app-title">
      <div>觅小书 — 高品质内容生态服务平台</div>
      <div class="app-subtitle">专注打造集社群运营、粉丝互动、商业变现于一体的专业服务平台</div>
    </div>
    <div class="qr-box">
      <vue-qr :logoSrc="require('@/assets/images/logo@2x.png')" :text="qrText" :size="400" :logoMargin="2"
              :logoCornerRadius="18" colorDark="#000000" :logo-scale="0.22" :margin="15"></vue-qr>
      <div class="qr-text">手机扫码访问</div>
    </div>
    <div class="install-notice">
      <div class="cant-download">官网地址：<a :href="officialUrl">{{ officialUrl }}</a></div>
    </div>
    <div v-if="isPC||isMac||isWin" class="both-platform">
      <div class="platform-btns">
        <div class="install-box-android">
          <template v-if="!matchedBrand">
            <template v-for="(apk,idx) in matchBrand" :key="idx">
              <a v-if="!apk.hide" class="install-btn slim android-btn" href="javascript:" @click="installApkUrl(apk.url)">Android 下载</a>
            </template>
          </template>
          <template v-if="matchedBrand">
            <a class="install-btn slim android-btn" href="javascript:" @click="installApkUrl(matchedBrand.url)">Android 下载</a>
            <!--            <a class="install-btn slim" href="javascript:" @click="installApk">其他请点这里下载</a>-->
          </template>
          <a class="install-btn ios-btn none-btn" href="javascript:" ><span>iPhone 下载</span></a>
        </div>
        <div class="install-box-pc">
          <a class="install-btn slim windows-btn" href="javascript:" @click="installWindowsUrl(windowsUrl)">Windows 下载</a>
          <a class="install-btn slim mac-btn none-btn" href="javascript:" @click="installMacUrl(macUrl)">Mac 下载</a>
        </div>
      </div>
      <div class="install-notice">
        <div v-if="apps.length > 0" class="notice-p">安装遇到困难，请<a :href="docUrl">查看帮助</a></div>
      </div>
    </div>
    <div v-else :class="'mobile-box' + (isIOS && isNoIosVersion ? ' no-version' : '')">
      <template v-if="isIOS">
        <div v-if="apps.length > 0 || appleUrl" class="install-box">
          <a v-if="apps[0]" class="install-btn ios-btn" href="javascript:"
             @click="install(apps[0])">Android 下载</a>
          <a v-if="appleUrl" class="install-btn ios-btn ios-black" :href="appleUrl">iPhone 下载</a>
          <a v-if="h5Url" class="install-btn web-btn none-btn" :href="h5Url">去网页版</a>
          <div v-if="version" class="version">觅小书App 应用版本：{{ version }} {{ build ? "(" + build + ")" : "" }}{{ iOSUpdateDate ? ' 应用更新时间：' + iOSUpdateDate : ''  }}</div>
          <div v-if="isIOS && apps.length > 0" class="install-notice">
            <div class="notice-p">安装遇到困难，请<a :href="docUrl">查看帮助</a></div>
          </div>
        </div>
        <div v-else-if="h5Url" class="install-box">
          <a v-if="h5Url" class="install-btn web-btn web-black" :href="h5Url">去网页版</a>
        </div>
      </template>
      <div v-else class="install-box">
        <template v-if="!matchedBrand">
          <template v-for="(apk,idx) in matchBrand" :key="idx">
            <a v-if="!apk.hide" class="install-btn slim android-btn" href="javascript:" @click="installApkUrl(apk.url)">{{ apk.notice }}</a>
          </template>
        </template>
        <template v-if="matchedBrand">
            <a class="install-btn slim android-btn" href="javascript:" @click="installApkUrl(matchedBrand.url)">{{ matchedBrand.notice }}</a>
<!--            <a class="install-btn slim" href="javascript:" @click="installApk">其他请点这里下载</a>-->
        </template>
        <div v-if="apkVersion" class="version">觅小书App 应用版本：{{ apkVersion }}{{ updateDate ? ' 应用更新时间：' + updateDate : ''  }}</div>
      </div>


      <div v-if="isWeibo || isQQ || isWx || isDy" class="mask">
        <img v-if="isAndroid" src="@/assets/images/mask1.png">
        <img v-else src="@/assets/images/mask.png">
      </div>

      <div v-if="showInstall" class="mask">
        <div class="alert-box">
          <div class="now-download" id="now-download">请等待安装完成，然后开始设置</div>
          <div class="a1">若安装后无法正常使用，请删除旧版APP</div>
          <div class="a2">请务必按以下步骤进行设置，详细 <a :href="docUrl"
                                                           style="color: #00A4FF;">安装教程</a>。
          </div>
          <div class="course" style="max-width: 100%;">
            <img style="width: 100%;max-width: 100%;" :src="require('@/assets/picture/course_' +currentIdx+ '.gif')">
            <div class="course_p">{{ stepMessages[currentIdx] }}</div>
          </div>
          <div class="close-btn2" @click="closeInstall"></div>
        </div>
      </div>
    </div>
    </div>
    <div class="view-img">
      <div class="buttons"><a :href="officialUrl" target="_blank">官网</a><a href="https://m.mixiaoshu.fun" target="_blank">登录网页版</a></div>
      <img src="@/assets/images/pic_download@2x.png"/>
    </div>

    <div class="bottom">
      <p><span class="com-name">Copyright © 2025 成都谦言科技有限公司</span></p>
      <p class="beian"><span><a href="http://beian.miit.gov.cn" target="_blank">{{beiAn}}</a></span> <span><img src="@/assets/images/index_icon_baimg@2x.png"/><a :href="`https://beian.mps.gov.cn/#/query/webSearch?code=${gongAnCode}`" rel="noreferrer" target="_blank">{{gongAn}}</a></span></p>
    </div>
  </div>
  <div v-if="isWx || isQQ || isDy" class="wx-content">
    <div class="text"><h3>如需浏览，请复制网址后使用<br/>浏览器访问</h3><div>{{mainUrl}} <a href="javascript:" @click="copyUrl">复制</a></div></div>
  </div>
</template>

<script>
import {post, getCache} from "@/utils/net";
import {loading, hideLoading} from "@/utils/toast";
import vueQr from 'vue-qr/src/packages/vue-qr.vue'
import useClipboard from 'vue-clipboard3'
import {Toast} from "vant";


const { toClipboard } = useClipboard();

export default {
  name: "AppInfo",
  components: {
    vueQr,
  },
  data: function () {
    return {
      version: "",
      build: "",
      ua: navigator.userAgent,
      appParam: {
        id: '',
        release: 1
      },
      beiAn: "蜀ICP备2025142045号",
      gongAnCode: "51019002008067",
      gongAn: `川公网安备 51019002008067号`,
      apps: [],
      switchIdx: 0,
      currentIdx: 0,
      showInstall: false,
      stepMessages: ["第1步：取消弹窗提示", "第2步：打开桌面的“设置”功能", "第3步：打开“通用”设置", "第4步：打开“VPN与设备管理”", "第5步：点击“企业级APP”", "第6步：点击蓝色文字“信任”", "第7步：点击弹窗中的“信任”,完成设置"],
      isAndroid: false,
      isIOS: false,
      isQQ: false,
      isPC: false,
      isWin: false,
      isMac: false,
      isWx: false,
      isWeibo: false,
      isSafari: false,
      isDy: false,
      loading: true,
      apkVersion: "",
      apkUrl: "",
      apkUrl2: "",
      docUrl: "",
      isNoIosVersion: false,
      qrText: window.location.href,
      officialUrl: "https://mquan.net",
      h5Url: "https://m.weme.fun",
      windowsUrl: "",
      macUrl: "",
      appleUrl: "",
      appleVersion: "",
      prefix: "itms-services://?action=download-manifest&url=",
      mainUrl: "",
      shareUrl: "",
      apk2Notice: "",
      apk2Match: "",
      matchBrand: [],
      matchedBrand: null,
      iOSMinVersion: [],
      updateDate: "",
      iOSUpdateDate: ""
    };
  },
  methods: {
    checkBrowser: function () {
      let isIosQQ = (/(iPhone|iPad|iPod|iOS)/i.test(this.ua) && /\sQQ/i.test(this.ua));
      let isAndroidQQ = (/(Android)/i.test(this.ua) && /MQQBrowser/i.test(this.ua) && /\sQQ/i.test(this.ua));
      let isAndroid = this.ua.indexOf('Android') > -1 || this.ua.indexOf('Adr') > -1; //android终端
      this.isQQ = isIosQQ || isAndroidQQ;
      this.isAndroid = isAndroid;
      this.isWeibo = /weibo/i.test(this.ua);
      this.isWx = /MicroMessenger/i.test(this.ua);
      this.isDy = /aweme|Bytedance/i.test(this.ua);

      if ((this.isWx || this.isQQ) && this.shareUrl && this.shareUrl !== window.location.href) {
        window.location.replace(this.shareUrl);
      } else if (!(this.isWx || this.isQQ) && this.mainUrl && this.shareUrl === window.location.href) {
        window.location.replace(this.mainUrl);
      }

      // check PC
      let Agents = ["Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod"];
      let flag = true;
      for (let v = 0; v < Agents.length; v++) {
        if (this.ua.indexOf(Agents[v]) > 0) {
          flag = false;
          break;
        }
      }
      this.isPC = flag;

      let agent = this.ua.toLowerCase();
      let isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
      let MAC = !isIOS && /macintosh|mac os x/i.test(navigator.userAgent) && !window.MSStream;

      this.isWin = agent.indexOf("win32") >= 0 || agent.indexOf("wow32") >= 0 || agent.indexOf("win64") >= 0 || agent.indexOf("wow64") >= 0

      this.isIOS = isIOS;
      this.isMac = MAC;

      this.isSafari = this.ua.indexOf("Safari") > -1 && this.ua.indexOf("Chrome") === -1; //判断是否Safari浏览器

      if (this.matchBrand && this.matchBrand.length > 0) {
        for (let i = 0; i < this.matchBrand.length; i++) {
          let match = this.matchBrand[i].match;
          if (!match) {
            continue;
          }
          let regex = new RegExp(match);
          if (!isIOS && regex.test(navigator.userAgent.toLowerCase())) {
            this.matchedBrand = this.matchBrand[i];
            break;
          }
        }
      }
    },
    copyUrl: async function () {
      try {
        await toClipboard(this.mainUrl);
        Toast.success('复制成功');
      } catch (e) {
        console.error(e);
      }
    },
    loopImage: function (currentIdx) {
      currentIdx = currentIdx + 1;
      if (currentIdx > 6) {
        currentIdx = 0;
      }
      let vm = this;
      this.currentIdx = currentIdx;
      clearTimeout(this.switchIdx);
      this.switchIdx = setTimeout(function () {
        vm.loopImage(vm.currentIdx);
      }, 4000);
    },
    increaseDownload: async function (uuid) {
      let l = loading();
      try {
        let res = await post("https://ipa.mixiaoshu.cc/Home/IncreaseDownload", {uuid, release: this.appParam.release});
        if (res.code === 404) {
          return false;
        }
      } catch (e) {
        console.log(e);
      }
      hideLoading(l);
      return true;
    },
    install: async function (item) {
      if (this.iOSMinVersion && this.iOSMinVersion.length > 0) {
        const regex = /iPhone OS (\d+)_(\d+)(_(\d+))? /;
        const ua = navigator.userAgent;
        const matched = ua.match(regex);
        if (matched) {
          if (matched[1] < this.iOSMinVersion[0]
              || matched[1] === this.iOSMinVersion[0] && matched[2] < this.iOSMinVersion[1]
              || matched[1] === this.iOSMinVersion[0] && matched[2] === this.iOSMinVersion[1] && (typeof (matched[4]) == "undefined" || matched[4] < this.iOSMinVersion[2])) {
            Toast.fail("系统版本低于" + this.iOSMinVersion.join(".") + "，不能安装");
            return;
          }
        }
      }
      this.showInstall = true;
      this.loopImage(-1);
      let res = await this.increaseDownload(item.uuid);
      if (res) {
        window.location.href = this.prefix + item.plistUrl;
      } else {
        window.location.reload();
      }
    },
    installApkUrl: function (url) {
      window.location.href = url;
    },
    installApk: function () {
      window.location.href = this.apkUrl;
    },
    installApk2: function () {
      window.location.href = this.apkUrl2;
    },
    installWindowsUrl: function (url) {
      window.location.href = url;
    },
    installMacUrl: function (url) {
      window.location.href = url;
    },
    closeInstall: function () {
      clearTimeout(this.switchIdx);
      this.currentIdx = 0;
      this.showInstall = false;
    },
    loadApp: async function () {
      if (this.isIOS || this.isPC || this.isMac || this.isWin) {
        let l = loading();
        try {
          let res = await post("https://ipa.mixiaoshu.cc/Home/Last", this.appParam);
          if (res.code === 200) {
            let data = res.data;
            if (data && data.length > 0) {
              this.version = data[0].appVersion;
              this.build = data[0].build;
              this.apps = data;
              const match = data[0].plistUrl.match(/\/(2\d{3})(\d{2})(\d{2})\//);
              if(match && match.length === 4){
                this.iOSUpdateDate = match[1] + "-" + match[2] + "-" +match[3];
              }
            } else if (this.appleUrl) {
              this.version = this.appleVersion;
            } else {
              this.isNoIosVersion = true;
              this.version = "暂无版本";
            }
          }
        } catch (e) {
          console.log(e);
        }
        hideLoading(l);
      }
    }
  },
  async mounted() {
    try {
      let file = window.configFile || "/config.json";
      let config = await getCache(file);
      if (config) {
        this.appParam.id = config.id;
        this.appParam.release = config.release;
        this.apkVersion = config.apkVersion;
        this.apkUrl = config.apkUrl;
        this.apkUrl2 = config.apkUrl2 || "";
        this.docUrl = config.docUrl;
        this.h5Url = config.h5Url || this.h5Url;
        this.windowsUrl = config.windowsUrl || this.windowsUrl;
        this.macUrl = config.macUrl || this.macUrl;
        this.officialUrl = config.officialUrl || this.officialUrl;
        this.appleUrl = config.appleUrl || this.appleUrl;
        this.appleVersion = config.appleVersion || this.appleVersion;
        this.mainUrl = config.mainUrl || this.mainUrl;
        this.shareUrl = config.shareUrl || this.shareUrl;
        this.apk2Notice = config.apk2Notice || this.apk2Notice;
        this.apk2Match = config.apk2Match || this.apk2Match;
        this.matchBrand = config.matchBrand || this.matchBrand;
        this.iOSMinVersion = config.iOSMinVersion || this.iOSMinVersion;
        this.updateDate = config.updateDate || this.updateDate;
      }
    } catch (e) {
      console.log(e);
    }

    this.checkBrowser();
    await this.loadApp();
    this.loading = false;
  }
}
</script>

<style scoped>
.logo-box {
  margin-top: 80px;
}

.page {
  text-align: center;
  overflow: auto;
  height: 100%;
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;


  background: url('@/assets/images/background.png') no-repeat;
  background-size:cover;
  width: 100%;
}

.page-main{
  text-align: center;
  overflow: auto;
  height: 100%;
  -webkit-overflow-scrolling: touch;
  position: relative;
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  flex:1;
  min-width: 320px;
}

.page .header {
  height: 100px;
  position: absolute;
  width: 100%;
  text-align: center;
  left: 0;
  top: 0;
  z-index: -1;
}

.page .logo {
  width: 80px;
  border-radius: 20px;
}
.page-pc .logo{
  border-radius: 5px;
}
.page .title {
  display: none;
}
.page-pc {
  position: relative;
}
.page-pc .logo-box{
  position: absolute;
  top:20px;
  left:20px;
  margin-top: 0;
  margin-left: 0;
  text-align: left;
}
.page-pc .logo-box .logo{
  width:24px;
  vertical-align: middle;
}
.page-pc .app-title{
  font-size: 50px;
  padding:0 10%;
}
.page-pc .app-subtitle{
  font-size: 18px;
  margin-top: 15px;
}
.page-pc .title{
  display: inline-block;
  text-align: left;
  font-size: 14px;
  font-weight: 300;
  font-family: "Alibaba PuHuiTi 2.0", var(--van-theme-font);
  vertical-align: middle;
  text-shadow: 1px 1px 10px #00000080;
  margin-left: 8px;
  color:#ffffff;
}

.app-title {
  margin-top: 10px;
  color: #ffffff;
  font-size: 18px;
  margin-bottom: 20px;
}

.title-img1 {
  width: 262px;
}
.title-img2 {
  width: 222px;
  margin-top: 6px;
}
.title-img3 {
  width: 140px;
  margin-top: 0;
  margin-bottom: 5px;
}

.app-title h2 {
  font-size: 24px;
  line-height: 33px;
  margin-bottom: -5px;
}

.version-info {
  color: var(--van-text-color-2);
  font-size: 14px;
  line-height: 1.6;
}

.version-info > div {
  display: inline-block;
}

.platform {
  border-right: 1px solid #DEE2EC;
  padding-right: 10px;
  margin-right: 5px;
}
.platform-notice {
  border-right: 1px solid transparent;
  padding-right: 10px;
  margin-right: 5px;
  color:#dd1100;
}

.version-info .version {
  margin-left: 5px;
}
.version {
  font-size: 14px;
  font-weight: 400;
  font-family: var(--van-theme-font);
  color: #ffffff;
  text-align: center;
  margin-top: 26px;
}

.install-box {
  margin-top: 25px;
  display: flex;
  flex-flow: column wrap;
  align-content: center;
  align-items: center;
}

.install-btn {
  text-decoration: none;
  padding: 4px 0;
  border-radius: 30px;
  font-size: 16px;
  width: 220px;
  text-align: center;
  font-weight: 400;
  font-family: "PingFang SC",var(--van-theme-font);
  line-height: 40px;
  color: #000000;
  background: #ffffff;
  border: 2px solid #ffffff;
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
}

.install-btn.android-btn{
  background: #ffffff;
  color: #000000;
  font-weight: 400;
}
.install-btn:before{
  content: ' ';
  width: 20px;
  height: 20px;
  display: block;
  margin-right: 5px;
  align-self: center;
}
.install-btn.android-btn:before{
  background: url("@/assets/images/icon_android_black.png") no-repeat center;
  background-size: contain;
}
.install-btn.ios-btn:before{
  background: url("@/assets/images/icon_ios@2x.png") no-repeat center;
  background-size: contain;
}
.install-btn.ios-btn.ios-black:before{
  background: url("@/assets/images/icon_ios_black.png") no-repeat center;
  background-size: contain;
}
.install-btn.windows-btn:before{
  background: url("@/assets/images/icon_pc_black.png") no-repeat center;
  background-size: contain;
}
.install-btn.mac-btn:before{
  background: url("@/assets/images/icon_mac@2x.png") no-repeat center;
  background-size: contain;
}
.install-btn.web-btn:before{
  background: url("@/assets/images/icon_web.png") no-repeat center;
  background-size: contain;
}
.install-btn.web-btn.web-black:before{
  background: url("@/assets/images/icon_web_black.png") no-repeat center;
  background-size: contain;
}
.install-btn.none-btn{
  background: transparent;
  color: #ffffff;
  font-size: 18px;
}
.install-btn.none-btn:before{

}

.install-btn + .install-btn {
  margin-top: 16px;
}


.install-notice {
  margin: 10px 0;
  font-size: 14px;
  line-height: 24px;
  color: var(--van-text-color);
  display: none;
}

.install-notice a {
  color: #00a4ff;
}

.cant-download {
  color: #212121;
  text-align: center;
  font-size: 17px;
  font-weight: 400;
  font-family: var(--van-theme-font);
}
.cant-download a{
  color:#5588C7;
  text-decoration: underline;
}

.mask {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 1000;
  background-color: rgba(0, 0, 0, 0.8);
}

.mask img {
  width: 100%;
}

.now-download {
  width: 100%;
  color: var(--van-text-color);
  margin-bottom: 14px;
  font-size: 17px;
  line-height: 20px;
  text-align: center;
}

.a1 {
  font-size: 15px;
  color: var(--van-text-color-2);
  text-align: center;
  margin-bottom: 17px;
}

.a2 {
  font-size: 15px;
  text-align: center;
  margin-bottom: 17px;
  font-weight: 500;
  color: #FF3333;
}

.course_p {
  max-width: 340px;
  height: 44px;
  line-height: 44px;
  padding: 0 11px;
  margin: 0 auto;
  font-size: 15px;
  color: var(--setup-color);
  text-align: center;
  background: var(--setup-background);
}

.alert-box {
  max-width: 500px;
  position: absolute;
  width: 86%;
  left: 50%;
  top: 50%;
  -webkit-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  background: var(--van-background);
  height: auto;
  padding: 3%;
  border-radius: 11px;
}

.close-btn2 {
  width: 28px;
  height: 28px;
  position: absolute;
  z-index: 3;
  background: url(~@/assets/images/close.png) no-repeat center;
  background-size: 100% auto;
  top: auto;
  bottom: -35px;
  left: 50%;
  margin-left: -14px;
}


.qr-box img {
  width: 130px;
  padding: 3px;
  border-radius: 10px;
  border: 2px solid #ffffff;
  background: #ffffff;
}
.qr-text{
  color: #ffffff;
  text-align: center;
  font-size: 16px;
  font-weight: 400;
  font-family: "PingFang SC", var(--van-theme-font);
  margin-top: 15px;
}

.both-platform {
  text-align: center;
  margin-top: 22px;
}
.both-platform .platform-btns{
  display:flex;
  flex-flow: row wrap;
  align-items: center;
  justify-content: space-around;
  max-width: 600px;
  margin: auto;
}
.both-platform  .install-btn{
  display: flex;
}

.platform-btns .install-btn{
  position: relative;
}
.platform-btns .install-btn.ios-btn:hover span{
  display: none;
}
.platform-btns .install-btn.ios-btn:hover:after{
  content:"扫描二维码下载";
}

.install-box-ios{
}
.install-box-android{
  margin-top: 10px;
}
.install-box-pc{
  margin-top: 10px;
}


.both-platform .install-notice {
  color: var(--van-text-color);
}

.ios-notice {
  font-size: 16px;
  color: var(--van-text-color);
}


.no-version .install-notice {
  margin: 30px auto;
}
.install-notice .notice-p{
  font-size: 17px;
  color: #212121;
  text-align: center;
  font-weight: 400;
  font-family: var(--van-theme-font);
}

.no-version .cant-download {
  font-size: 20px;
  line-height: 40px;
}
.wx-content {
  height:100%;
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  text-align: center;
}
@media screen and (max-width: 410px) {
  .logo-box {
    margin-top: 60px;
  }
}
@media screen and (max-width: 400px) {
  .logo-box {
    margin-top: 40px;
  }
}
@media screen and (max-width: 390px) {
  .logo-box {
    margin-top: 20px;
  }
}

.view-img{
  padding-right: 100px;
  padding-left: 20px;
  height: 100%;
  min-height: 640px;
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  align-content: center;
  justify-content: center;
}
.view-img .buttons{
  padding:10px 0;
  margin-top: -120px;
  margin-bottom: 120px;
}
.view-img .buttons a {
  color: #ffffff;
  font-size: 18px;
  border: 2px solid #ffffff;
  display: inline-block;
  border-radius: 20px;
  width: 180px;
  text-align: center;
  height: 40px;
  line-height: 40px;
  margin-right:30px;
  font-weight: 400;
}
.view-img .buttons a:hover{
  background: #ffffff;
  color: #000000;
}
.view-img img{
  width: 500px;
}

.bottom{
  color:#FFFFFF;
  font-size: 14px;
  line-height: 22px;
  text-align: center;
  margin-top: 15px;
  position: fixed;
  bottom: 20px;
  width: 100%;
  a{
    color:#FFFFFF;
    vertical-align: middle;
    font-size: 14px;
    line-height: 22px;
  }
  p{
    vertical-align: middle;
    img{
      width:16px;
      vertical-align: middle;
      margin-left: 10px;
      margin-right: 2px;
    }
  }
}

@media screen and (max-width: 641px){
  .page{
    max-width: 640px;
    display: block;
    flex-flow: column nowrap;
  }
  .page-main{
    height: auto;
    min-height: 720px;
  }
  .view-img{
    display: none;
  }
  .bottom {
    position: static;
  }
}
</style>